import { createFileRoute } from '@tanstack/react-router';

import { AdminEditUserModal } from '~/components/modals/user/AdminEditUserModal';
import { USER_ROLES } from '~/features/auth/roles';
import { useGoBack } from '~/hooks/useGoBack';
import { Route as HcpAdminUsersRoute } from '~/routes/user-administration/users';
import { protectedRoute } from '~/utils/routesAuthorization';

const TEST_ID = 'user-details';

export const Route = createFileRoute(
  '/user-administration/users/profile/$userId',
)({
  component: EditUserRoute,
  params: {
    parse: (params) => ({ userId: params.userId }),
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.HcpAdmin, USER_ROLES.NonHcpAdmin],
    });
  },
});

function EditUserRoute() {
  const { userId } = Route.useParams();

  const goBack = useGoBack({ fallbackPath: HcpAdminUsersRoute.fullPath });

  return (
    <AdminEditUserModal
      testID={TEST_ID}
      userId={userId}
      onCloseRedirectPath={HcpAdminUsersRoute.fullPath}
      onActionComplete={goBack}
    />
  );
}
